/**
 * @param {import("./homeLayoutContext").HomeSection} section
 * @param {{ authStatus: string, isHomeSearching: boolean }} ctx
 */
export const shouldShowHomeSection = (section, {authStatus, isHomeSearching}) => {
  const placement = section.placement || "both";

  if (placement === "authenticated" && authStatus !== "authenticated") {
    return false;
  }
  if (placement === "unauthenticated" && authStatus !== "unauthenticated") {
    return false;
  }

  const conditions = section.conditions || {};
  if (conditions.hide_when_searching && isHomeSearching) {
    return false;
  }

  return true;
};
